<template>
  <div
    id="login"
    class="row justify-content-center bg-general"
  >
    <div class="col-sm-12 col-md-9 col-lg-4">
      <div class="logo stack-on-top" />
      <div class="jumbotron jumb justify-content-center d-sm-none d-md-block">
        <div
          v-if="alert.message"
          :class="`alert ${alert.type}`"
          role="alert"
        >
          {{ alert.message }}
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="login">
            <ValidationProvider
              v-for="input in inputs"
              :key="input.name"
              v-slot="{ errors }"
              mode="aggressive"
              :rules="input.rules"
              persist
            >
              <label :for="input.name">{{ input.label }}</label>
              <input
                v-model="input.value"
                :name="input.name"
                :type="input.type"
                class="form-control"
                :class="{ 'is-invalid': errors[0] }"
              >
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
            <br>
            <primary-button
              title="Sign in"
              classes="btn btn-primary btn-block"
              :loading="isLoaing"
              :disabled="invalid"
            />
            <hr>
            <div>
              <small>
                <strong>Don’t have an account contact your admin to create one for
                  you</strong>
              </small>
            </div>
          </form>
        </ValidationObserver>
        <router-link to="/passwords/reset">
          <small>
            <strong>Forgot password?</strong>
          </small>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PrimaryButton from "../components/Buttons/PrimaryButton.vue";
import { roles } from "../helpers/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  name: "Login",
  components: {
    PrimaryButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      inputs: [
        {
          label: "Phone Number",
          name: "phone",
          type: "tel",
          rules: "required|phone|digits:10",
          value: "",
        },
        {
          label: "Password",
          name: "password",
          type: "password",
          rules: "required|min:6",
          value: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isLoaing: "auth/isLoading",
    }),
    alert() {
      return this.$store.state.alert;
    },
  },
  methods: {
    login: function () {
      let phoneNumber = this.inputs[0].value;
      let password = this.inputs[1].value;
      this.$store
        .dispatch("auth/login", {
          phoneNumber,
          password,
        })
        .then((role) => {
          this.clear();
          switch (role) {
            case roles.ADMIN:
              this.$router.push("admin");
              break;
            case roles.SUPER_ADMIN:
              this.$router.push("admin");
              break;
            case roles.SUPERVISOR:
              this.$router.replace("supervisor");
              break;
            case roles.AGENT:
              this.$router.push("agent");
              break;
            default:
              return;
          }
        })
        .catch(() => {
          //return console.log(err);
        });
    },
    clear: function () {
      this.$store.dispatch("alert/clear");
    },
  },
};
</script>

<style scoped>
#login {
  height: 100vh;
}

.jumb {
  margin-top: 25vh;
  padding-top: 15vh;
  position: relative;
}

.logo {
  position: absolute;
  height: 76px;
  width: 76px;
  top: 0;
  left: 0;
  background: url("../assets/images/logo.png");
}

.stack-on-top {
  z-index: 1;
  margin: 20vh 0 0 42%;
}
</style>
